import React from "react"
import styled from "styled-components"
import { StepContainer } from "../../styles/reusables"
import { Copy } from "../../styles/typography"
import { MainButton, BackButton } from "../../styles/buttons"

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  button {
    min-width: 150px;
  }

  button:nth-child(1) {
    margin-right: 10px;
  }

  button:nth-child(2) {
    margin-left: 10px;
  }
`

const NewUserChoices = ({ setStep }) => {
  return (
    <StepContainer>
      <Copy>
        You can select between having a custom site designed from scratch or a
        pre-made wipay + shopify template
      </Copy>
      <Actions>
        <a href="https://wipaycaribbean.com/products/wishops">
          <MainButton onClick={() => null}>Wipay Templates</MainButton>
        </a>
        <MainButton onClick={() => setStep(5)} whileHover={{ scale: 1.01 }}>
          Custom Design
        </MainButton>
      </Actions>

      <BackButton onClick={() => setStep(1)} style={{ marginTop: "50px" }}>
        Go Back
      </BackButton>
    </StepContainer>
  )
}

export default NewUserChoices
